import {defineStore} from 'pinia'
import {sessionStore} from '@/store/pinia/sessionStore'
import EventService from "@/services/APIService";

export const twoFactorAuthStore = defineStore('PlingTwoFactorAuthStore', {
    state: () => {
        return {

            requires2FA: false,
            available2FAMethods: [],
            availableFallback2FAMethods: [],
            all2FAMethods: [],
            verificationLoading: false,
            selected2FAMethod: null,
            canDismiss: true,
        }
    }, actions: {
        async verify2FACode({code, method, trust_device = false}) {
            this.verificationLoading = true
            try {
                const response = await EventService.post('/auth/2fa/verify', {
                    code, method, trust_device,
                }, { suppressToast: true })
                return response;
            } finally {
                this.verificationLoading = false
            }
        },

        async resendCode() {
            return EventService.post('/auth/2fa/resend', {
                method: this.selected2FAMethod?.slug
            })
        },

        clear2FAState() {
            this.verificationLoading = false;
            this.available2FAMethods = [];
            this.all2FAMethods = [];
            this.selected2FAMethod = null;
        },

        async register2FAMethod() {
            this.verificationLoading = true
            try {
                const response = await EventService.post('/auth/2fa/method/register', {
                    method: this.selected2FAMethod?.slug
                })

                if (response?.data?.payload) {
                    if (this.selected2FAMethod.slug === 'totp') {
                        this.selected2FAMethod.totp_qr_code_url = response.data.payload.totp_qr_code_url
                        this.selected2FAMethod.totp_secret = response.data.payload.totp_secret
                    }
                }

                return response
            } finally {
                this.verificationLoading = false
            }
        },

        async cancelRegister2FAMethod() {
            this.verificationLoading = true;
            try {
                return await EventService.post('/auth/2fa/method/register/delete', {
                    method: this.selected2FAMethod?.slug,
                })
            } finally {
                this.verificationLoading = false
            }
        },

        async resendRegister2FAEmailCode() {
            if (this.selected2FAMethod?.slug !== 'email') {
                return Promise.reject(new Error('Method is not email'))
            }

            return EventService.post('/auth/2fa/method/register/resend', {
                method: this.selected2FAMethod?.slug
            })
        },

        async checkRegister2FAMethodCode(code, pending_method = null) {
            this.verificationLoading = true
            try {
                const response = await EventService.post('/auth/2fa/method/register/verify', {
                    code: code,
                    method: this.selected2FAMethod?.slug,
                    pending_method: pending_method
                }, { suppressToast: true }).then((response) => {
                    this.availableFallback2FAMethods = response.data.payload?.fallback_methods ?? null;
                    if (this.availableFallback2FAMethods) {
                        this.availableFallback2FAMethods = Object.values(this.availableFallback2FAMethods);
                    }
                    return response;
                });

                return response;

            } finally {
                this.verificationLoading = false
            }
        }
    },
})
